import BookingWizard from "../components/BookingWizard";
import { Kicker, Reveal } from "../components/Reveal";

export default function BookPage() {
  return (
    <main data-testid="book-page" className="bg-ivory pb-28 pt-16">
      <div className="mx-auto max-w-5xl px-6 sm:px-8">
        <Reveal>
          <Kicker>Booking</Kicker>
          <h1 className="mt-4 font-serif text-4xl font-medium leading-tight tracking-tight text-forest sm:text-5xl">
            Book your visit
          </h1>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-moss sm:text-base">
            Reserve your time online — no card required. Pay at your visit.
            Questions first? Call Nichole at 801-797-7060.
          </p>
        </Reveal>
        <Reveal delay={0.1} className="mt-10">
          <BookingWizard />
        </Reveal>
      </div>
    </main>
  );
}
